<template>
  <div id="tags-view-container" class="tags-view-container">
    <scroll-pane ref="scrollPane" class="tags-view-wrapper" @scroll="handleScroll">
      <router-link v-for="tag in visitedViews" :key="`${tag.path}-${JSON.stringify(tag.query)}`" ref="tag"
                   :class="currentTag == tag.path ? 'active' : ''" :to="{ path: tag.path, query: tag.query }"
                   class="tags-view-item" @click.middle.native="!isAffix(tag) ? closeSelectedTag(tag) : ''"
                   @contextmenu.prevent.native="openMenu(tag, $event)">
        {{ $t(`menus.${tag.title}`) }}
        <span v-if="!isAffix(tag)" class="el-icon-close" @click.prevent.stop="closeSelectedTag(tag)" />
      </router-link>
    </scroll-pane>

    <ul v-show="visible" :style="{ left: left + 'px', top: top + 'px' }" class="contextmenu">
      <!--      <li @click="refreshSelectedTag(selectedTag)">刷新</li>-->
      <li v-if="!isAffix(selectedTag)" @click="closeSelectedTag(selectedTag)">{{ $t('Admin.closing') }}</li>
      <li @click="closeOthersTags">{{ $t('Admin.closeOther') }}</li>
      <li @click="closeAllTags(selectedTag)">{{ $t('Admin.closeAll') }}</li>
    </ul>
  </div>
</template>

<script>
import ScrollPane from './ScrollPabe.vue'

export default {
  name: 'TagsView',
  components: { ScrollPane },
  prop: {
    isRouterAlive: {
      type: Boolean,
      default: true
    },

  },
  data () {
    return {
      visible: false,
      top: 0,
      left: 0,
      selectedTag: {},
      affixTags: [],
      currentTag: '/index'
    }
  },

  computed: {
    visitedViews () {
      return this.$store.state.d2admin.tagsView.visitedViews||[]
    },
    routes () {
      return this.$router.options.routes
    }
  },
  watch: {
    $route () {
      this.addTags()
      this.moveToCurrentTag()
      this.isActive()
    },
    visible (value) {
      if (value) {
        document.body.addEventListener('click', this.closeMenu)
      } else {
        document.body.removeEventListener('click', this.closeMenu)
      }
    }
  },
  mounted () {
    // 初始化标签
    this.initTags()

    // 添加当前路由
    this.addTags()

    // 添加路由监听
    this.$router.afterEach(this.addTags)
  },
  beforeDestroy () {
    // 移除路由监听
    this.$router.afterEach(this.addTags)
  },
  methods: {
    isActive () {
      // return tag.path === this.$route.path;
      this.visitedViews.forEach((item) => {
        if (item.path == this.$route.path) {
          this.currentTag = item.path
        }
      });
    },
    isAffix (tag) {
      return tag.meta && tag.meta.affix
    },
    initTags () {
      // 不再需要此方法，完全由 store 管理
    },
    addTags () {
      if (this.$route.name && !this.$route.meta?.hidden) {
        this.$store.dispatch('d2admin/tagsView/addView', this.$route)
      }
    },
    moveToCurrentTag () {
      const tags = this.$refs.tag || []
      this.$nextTick(() => {
        for (const tag of tags) {
          if (tag.to.path === this.$route.path) {
            this.$refs.scrollPane.moveToTarget(tag)
            if (tag.to.fullPath !== this.$route.fullPath) {
              this.$store.dispatch('d2admin/tagsView/updateVisitedView', this.$route)
            }
            break
          }
        }
      })
    },

    closeSelectedTag (view) {
      this.$store.dispatch('d2admin/tagsView/delView', view).then(() => {
        // 确保路由跳转到有效标签
        const lastView = this.visitedViews.slice(-1)[0]
        if (lastView) {
          this.$router.push(lastView.fullPath)
        } else {
          this.$router.push('/index')
        }
      })

    },
    closeOthersTags () {
      this.$router.push(this.selectedTag)
      this.$store.dispatch('d2admin/tagsView/delOthersViews', this.selectedTag).then(() => {
        this.moveToCurrentTag()
      })
    },
    closeAllTags (view) {
      this.$store.dispatch('d2admin/tagsView/delAllViews').then(({ visitedViews }) => {
        if (this.affixTags.some(tag => tag.path === view.path)) return
        this.toLastView(visitedViews, view)
      })
    },
    toLastView (visitedViews, view) {
      const latestView = visitedViews.slice(-1)[0]
      if (latestView) {
        this.$router.push(latestView.fullPath)
      } else {
        this.$router.push('/')
      }
    },
    openMenu (tag, e) {
      const menuMinWidth = 105
      const offsetLeft = this.$el.getBoundingClientRect().left
      const offsetWidth = this.$el.offsetWidth
      const maxLeft = offsetWidth - menuMinWidth
      const left = e.clientX - offsetLeft + 15

      this.left = left > maxLeft ? maxLeft : left
      this.top = e.clientY
      this.visible = true
      this.selectedTag = tag
    },
    closeMenu () {
      this.visible = false
    },
    handleScroll () {
      this.closeMenu()
    }
  }
}
</script>


<style lang="scss" scoped>
.tags-view-container {
  height: 54px;
  width: 100%;
  background: #fff;
  border-bottom: 1px solid #d8dce5;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .12), 0 0 3px 0 rgba(0, 0, 0, .04);

  .tags-view-wrapper {
    .tags-view-item {
      display: inline-block;
      position: relative;
      cursor: pointer;
      height: 42px;
      line-height: 42px;
      border: 1px solid #d8dce5;
      color: #495060;
      background: #fff;
      padding: 0 8px;
      font-size: 18px;
      margin-left: 5px;
      margin-top: 4px;

      &:first-of-type {
        margin-left: 15px;
      }

      &:last-of-type {
        margin-right: 15px;
      }

      &.active {
        background-color: #5a9cf8;
        color: #fff;
        border-color: #5a9cf8;

        &::before {
          content: '';
          background: #fff;
          display: inline-block;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          position: relative;
          margin-right: 2px;
        }
      }
    }
  }

  .contextmenu {
    margin: 0;
    background: #fff;
    z-index: 3000;
    position: absolute;
    list-style-type: none;
    padding: 5px 0;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 400;
    color: #333;
    box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, .3);

    li {
      margin: 0;
      padding: 7px 16px;
      cursor: pointer;

      &:hover {
        background: #eee;
      }
    }
  }
}
</style>

<style lang="scss">
.tags-view-wrapper {
  .tags-view-item {
    .el-icon-close {
      width: 16px;
      height: 16px;
      vertical-align: 2px;
      border-radius: 50%;
      text-align: center;
      transition: all .3s cubic-bezier(.645, .045, .355, 1);
      transform-origin: 100% 50%;

      &:before {
        transform: scale(.6);
        display: inline-block;
        vertical-align: -3px;
      }

      &:hover {
        background-color: #b4bccc;
        color: #fff;
      }
    }
  }
}
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/layout/header-aside/components/TagsView/index.vue"
}
</vue-filename-injector>
